import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { dropdownAction, giftFormAction } from "../../redux/rootReducer";
import { GIFT_FORM_INITIAL } from "../../redux/initialStateConstant";
import TextareaAutosize from "react-textarea-autosize";
import { getPriceSagaAction, updateGiftSagaAction } from "../../redux/sagaActions";

const GiftForm = () => {
    const dispatch = useDispatch();

    const giftForm = useSelector(state => state.giftForm);
    const establishmentList = useSelector(state => state.establishmentList);
    const price = useSelector(state => state.price);
    const dropdown = useSelector(state => state.dropdown);

    useEffect(() => {
        // Запрашиваем прайс, если прайс пустой
        if (!price.length) {
            dispatch(getPriceSagaAction());
        }
    }, []);

    if (!giftForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                            onClick={ () => dispatch(giftFormAction(GIFT_FORM_INITIAL)) }
                        />
                        <div className="form__title">{ giftForm.id ? `Бонус № ${ giftForm.id }` : 'Добавление бонуса' }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название бонуса</div>
                        <input type="text" className="input"
                            value={ giftForm.name }
                            onInput={ event => dispatch(giftFormAction({ ...giftForm, name: event.target.value })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Стоимость баллов</div>
                        <input type="text" className="input"
                            value={ giftForm.cost }
                            onInput={ event => dispatch(giftFormAction({ ...giftForm, cost: event.target.value })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Автоматическое начисление бонуса</div>
                        <div className="dropdown">
                            <div className="input input--tick"
                                 onClick={ () => dispatch(dropdownAction('price_id')) }
                            >{
                                giftForm.price_id !== '0'
                                ? price.find(el => el.id === giftForm.price_id)?.name
                                : 'Без автоматического начисления'
                            }</div>
                            <div className={ `dropdown__items ${ dropdown === 'price_id' ? 'dropdown__items--open' : '' }` }>
                                <div className="dropdown__item"
                                     onClick={ () => {
                                         dispatch(giftFormAction({ ...giftForm, price_id: '0' }));
                                         dispatch(dropdownAction(null));
                                     } }
                                >Без автоматического начисления</div>
                                {
                                    price.map(elem => {
                                        return (
                                            <div className="dropdown__item"
                                                 key={ elem.id }
                                                 onClick={ () => {
                                                     dispatch(giftFormAction({ ...giftForm, price_id: elem.id }));
                                                     dispatch(dropdownAction(null));
                                                 } }
                                            >{ elem.name }</div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Описание</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ giftForm.description }
                            onInput={ event => dispatch(giftFormAction({
                                ...giftForm,
                                description: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...giftForm.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(giftFormAction({
                                                ...giftForm,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ giftForm.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 dispatch(updateGiftSagaAction({
                                     id: giftForm.id,
                                     name: giftForm.name,
                                     cost: giftForm.cost,
                                     description: giftForm.description,
                                     establishments: JSON.stringify(giftForm.establishments),
                                     price_id: giftForm.price_id
                                 }));
                             } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GiftForm;